// extracted by mini-css-extract-plugin
export var colorSquare = "_up-0";
export var danger = "_up-5";
export var lightPink = "_up-8";
export var neutralBlue = "_up-7";
export var neutralYellow = "_up-6";
export var normal = "_up-1";
export var primary = "_up-2";
export var primaryLight = "_up-3";
export var solidBlack = "_up-g";
export var solidGreen = "_up-b";
export var solidLightBlue = "_up-d";
export var solidNavy = "_up-c";
export var solidOrange = "_up-f";
export var solidPink = "_up-e";
export var solidRed = "_up-9";
export var solidYellow = "_up-a";
export var success = "_up-4";